
import IncrediTextInput from '@/components/inputs/incrediTextInput.vue';
import TooltipBtn from '@/components/common/TooltipBtn.vue';
import { defineComponent, inject, PropType } from 'vue';
import { useStore } from 'vuex';
import { IKSettingsDirty } from '@/types/injectionKeys';
import { useSettingsPageWindowsQuery, QUERY_RESULT_PATH, SettingsPageWindowsQuery } from '@/graphql/codegen/generated/graphql';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';

export default defineComponent({
  name: 'AgentCertificateValidation',
  components: { IncrediTextInput, TooltipBtn },
  props: {
    disable: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: Object as PropType<NonNullable<SettingsPageWindowsQuery['ibManagerEntities']>>,
      required: true,
    },
  },
  setup() {
    const coordinatorsService = inject(IKCoordinatorsService);

    const settingsDirty = inject(IKSettingsDirty);
    const { result: GQL_Settings } = useSettingsPageWindowsQuery(() => ({ coordinatorId: coordinatorsService?.selectedCoordinator.value || '' }));
    const store = useStore();
    return {
      GQL_Settings,
      QUERY_RESULT_PATH,
      store,
      settingsDirty,
    };
  },
  data() {
    return {
      validationTriggered: null as any,
    };
  },
  methods: {
    isRegExpValid(text: any) {
      let isValid: any = false;
      try {
        isValid = RegExp(text);
        this.store.commit('settings/setRegExpValidation', !!isValid);
      } catch (error) {
        this.store.commit('settings/setRegExpValidation', !!isValid);
        this.validationTriggered = true;
        return false;
      }
      this.validationTriggered = false;
      return true;
    },
  },
});
